// Production Configuration
// This file contains production-specific settings

export const PROD_CONFIG = {
  // API Configuration - Use relative URLs for nginx proxy
  API_BASE_URL: '',
  
  // Server Configuration
  SERVER_NAME: 'ubuntu24',
  DOMAIN: 'mgauto.mywire.org',
  
  // Feature Flags
  ENABLE_LOGGING: false,
  ENABLE_DEBUG_MODE: false,
  
  // Mock Data (disabled in production)
  USE_MOCK_DATA: false,
  
  // CORS Settings
  CORS_ENABLED: true,
  
  // Timeout Settings
  API_TIMEOUT: 15000, // 15 seconds for production
  
  // Retry Settings
  MAX_RETRIES: 2,
  RETRY_DELAY: 2000, // 2 seconds
  
  // Security Settings
  ENABLE_HTTPS: true,
  STRICT_SSL: true,
  
  // Performance Settings
  ENABLE_CACHING: true,
  CACHE_DURATION: 300000, // 5 minutes
  
  // Monitoring
  ENABLE_ERROR_TRACKING: true,
  LOG_LEVEL: 'error' // Only log errors in production
};

// Helper function to check if running in production
export const isProdEnvironment = () => {
  return process.env.NODE_ENV === 'production' || 
         window.location.hostname !== 'localhost' ||
         window.location.hostname !== '127.0.0.1' ||
         window.location.port !== '3000';
};

// Helper function to get production API URL
export const getProdApiUrl = (endpoint = '') => {
  return `${PROD_CONFIG.API_BASE_URL}${endpoint}`;
};

// Production-specific API endpoints
export const PROD_API_ENDPOINTS = {
  // Invoice endpoints
  invoices: `${PROD_CONFIG.API_BASE_URL}/api/invoices`,
  invoiceById: (id) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/${id}`,
  invoicePrint: (id) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/${id}/print`,
  invoicePdf: (id) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/${id}/pdf`,
  invoiceEmail: (id) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/${id}/email`,
  invoiceStatus: (id) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/${id}/status`,
  invoiceDashboard: (period) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/dashboard/sales?period=${period}`,
  invoicesByCustomer: (customerId) => `${PROD_CONFIG.API_BASE_URL}/api/invoices/by-customer?customerId=${customerId}`,
  
  // Customer endpoints
  customers: `${PROD_CONFIG.API_BASE_URL}/api/customers`,
  customerSearch: (phone) => `${PROD_CONFIG.API_BASE_URL}/api/customers/search?phone=${encodeURIComponent(phone)}`,
  
  // Vehicle endpoints
  vehicles: `${PROD_CONFIG.API_BASE_URL}/api/vehicles`,
  
  // Health endpoints
  health: `${PROD_CONFIG.API_BASE_URL}/health`,
  healthApi: `${PROD_CONFIG.API_BASE_URL}/health/api`
};

export default PROD_CONFIG;
